import { Logo } from '@seek/logo';
import { useMelwaysInfo } from '@seek/melways-react';
import { Stack, Loader, Box } from 'braid-design-system';

import * as styles from './FullScreenLoader.css.ts';

export const FullScreenLoader = () => {
  const { brand } = useMelwaysInfo();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="spaceBetween"
      className={styles.content}
      background="surface"
    >
      <Stack space="none" align="center">
        <div className={styles.loader}>
          <Loader />
        </div>
        <div className={styles.logo}>
          <Logo brand={brand} />
        </div>
      </Stack>
    </Box>
  );
};
